export const riskPreferenceColor = '#5995ED';
export const riskCapacityColor = '#FFAD05';
